import React, { FC, useCallback } from "react";
import { UserVehicleControl } from "../../../../../../../domain/control/Vehicle";
import { FixedSizeList as List } from "react-window";
import { AutoSizer, Size } from "react-virtualized";
import { VehicleSearchRow } from "./row";
import { EmptyState } from "../../../../../../components/state/empty";
import { faList, faSearch } from "@fortawesome/free-solid-svg-icons";

export type VehicleSearchListProps = {
  items: UserVehicleControl[] | null;
  onClick: (vehicle: UserVehicleControl, type: string) => void;
};

export type VehicleSearchListRowProps = {
  items: UserVehicleControl[];
  onClick: React.MouseEventHandler<HTMLDivElement>;
};

export const VehicleSearchListWindow: FC<VehicleSearchListProps> = ({
  items,
  onClick,
}) => {
  /* eslint-disable */
  const onRowClick = useCallback<React.MouseEventHandler<HTMLDivElement>>(
    (e) => {
      if (!items) return;
      const index = e.currentTarget.dataset.index;
      if (index) {
        onClick(items[index as unknown as number], "VehicleControl");
      }
    },
    [items]
  );

  /* eslint-enable */

  return items === null ? (
    <EmptyState
      icon={faSearch}
      title={"Buscar Vehiculos"}
      message={"Ingrese un término de búsqueda."}
    />
  ) : items.length > 0 ? (
    //@ts-ignore
    <AutoSizer>
      {(props: Size) => (
        <List
          height={props.height}
          itemCount={items?.length || 0}
          itemSize={200}
          width={props.width}
          itemData={{
            items,
            onClick: onRowClick,
          }}
        >
          {VehicleSearchRow}
        </List>
      )}
    </AutoSizer>
  ) : (
    <EmptyState
      icon={faList}
      title={"Sin resultados"}
      message={`No hay vehiculos que coincidan con la búsqueda.`}
    />
  );
};
